<template>
  <div class="hp-base-panel-wrp hp-base-panel-wrp-new">
    <div class="desc" @click="showEnsure">
      <img
        class="icon-care"
        src="~images/platform/homepage/icon-care.png"
        alt=""
      />
      <div class="desc-right">
        <span class="desc-text"
          >隐私保护 · 严格筛选 · 资质担保 · 7天退款到账</span
        >
        <img
          class="arrow-3"
          src="~images/platform/homepage/right-arrow-2.png"
        />
      </div>
    </div>
    <div class="qingsu-panel hp-base-panel">
      <div
        class="service-item"
        :class="{ active: qingsuType === item.type }"
        v-for="item in serviceMsg"
        :key="item.type"
        @click="onSelect(item.type)"
      >
        <div>
          <div class="title">
            <div class="name">
              {{ item.name }}
            </div>
            <div class="tips" v-if="item.tip">
              {{ item.tip }}
            </div>
          </div>
          <div class="price">
            <div class="now">{{ item.price }}</div>
            <div class="origin" v-if="item.originPrice">
              {{ item.originPrice }}
            </div>
            <div class="package">{{ item.package }}</div>
          </div>
        </div>
        <div class="btn" @click.stop="toQingsuOrder(item)">
          <img
            :src="
              require(`../../../../images/platform/homepage/${item.icon}.png`)
            "
          />
        </div>
      </div>
    </div>
    <ensureRuleModel :show.sync="isShowEnsure" />
  </div>
</template>

<script>
import ensureRuleModel from './ensureRuleModel.vue'
import { EventBus } from 'component/platform/homepage/eventBus.js'

export default {
  components: {
    ensureRuleModel
  },
  data() {
    return {
      isShowEnsure: false
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
    qingsuService() {
      return this.$store.state.homepage.qingsuService
    },
    teacherInfo() {
      return this.qingsuService.info || {}
    },
    consultationText() {
      return this.qingsuService.consultation_text || {}
    },
    discountInfo() {
      return this.qingsuService.discount_info || {}
    },
    qingsuType() {
      return this.$store.state.homepage.qingsuType
    },
    iconNameMaps() {
      // 0：休息中  1：空闲中  2:服务中
      return {
        0: 'btn-qingsu-rest',
        1: {
          voice: 'btn-qingsu-call',
          text: 'btn-qingsu-chat'
        },
        2: 'btn-qingsu-service'
      }
    },
    serviceMsg() {
      // 是否提供文字倾诉服务 0否 1是
      const is_provide_text = Number(this.teacherInfo.is_provide_text)
      // 是否提供语音倾诉服务 0否 1是
      const is_provide_voice = Number(this.teacherInfo.is_provide_voice)
      // 文字倾诉价格
      const consultation_price = Number(
        this.consultationText.consultation_price
      )
      // 文字倾诉服务状态
      const text_status = +this.teacherInfo.text_status

      // 语音倾诉价格
      const voice_price = Number(this.teacherInfo.voice_price)
      // 语音倾诉是否首单 0否 1是
      const firstOrder = Number(this.discountInfo.firstOrder)
      // 语音倾诉服务状态
      const ting_status = +this.teacherInfo.ting_status

      const isShowCharity = this.teacherInfo.is_show_charity > 0
      const restcharityNum = this.teacherInfo.restcharity_num > 0

      // 0元体验
      const isShowZeroExperience = +this.teacherInfo.is_show_zeroexperience
      const self = this
      const result = [
        {
          name: '语音倾诉',
          type: 'voice',
          get price() {
            if ((isShowCharity && restcharityNum) || isShowZeroExperience)
              return '￥0'
            if (is_provide_voice === 0) {
              return ''
            }
            return `￥${voice_price}`
          },
          get icon() {
            if (is_provide_voice === 0) {
              return ''
            }
            const icon =
              ting_status === 1
                ? self.iconNameMaps[ting_status].voice
                : self.iconNameMaps[ting_status]
            return icon
          },
          get tip() {
            if (is_provide_voice === 0) {
              return ''
            }
            if (isShowZeroExperience) return '0元体验'
            if (isShowCharity && restcharityNum) return '0元公益'
            if (firstOrder) {
              return `首单${voice_price}元`
            }
            return ''
          },
          get originPrice() {
            const pkg30Min = self.teacherInfo.price.find(
              item => +item.minute === 30
            )
            const target = pkg30Min || self.teacherInfo.price[0]
            return target && target.price > voice_price
              ? `￥${target.price}`
              : ''
          },
          get package() {
            const pkg30Min = self.teacherInfo.price.find(
              item => +item.minute === 30
            )
            return `/${pkg30Min ? 30 : self.teacherInfo.price[0].minute}分钟`
          },
          shown: is_provide_voice
        },
        {
          name: '文字倾诉',
          type: 'text',
          package: '/5回合',
          get price() {
            if (is_provide_text === 0) {
              return ''
            }
            return `￥${consultation_price}`
          },
          get icon() {
            if (is_provide_text === 0) {
              return ''
            }
            const icon =
              text_status === 1
                ? self.iconNameMaps[text_status].text
                : self.iconNameMaps[text_status]
            return icon
          },
          get tip() {
            if (is_provide_text === 0) {
              return ''
            }
            return consultation_price === 0 ? '首单免费' : ''
          },
          shown: is_provide_text
        }
      ]
      return result.filter(v => v.shown)
    }
  },
  created() {
    const { qingsuService } = this.$route.query
    const is_provide_voice = Number(this.teacherInfo.is_provide_voice)
    const is_provide_text = Number(this.teacherInfo.is_provide_text)
    this.$store.commit(
      'homepage/SET_QINGSU_TYPE',
      is_provide_text && (+qingsuService === 1 || !is_provide_voice)
        ? 'text'
        : 'voice'
    )
  },
  methods: {
    showEnsure() {
      this.$trackEvent('newprofilepages_listener_guarantee', {})
      this.isShowEnsure = true
    },
    toQingsuOrder(item) {
      const { type } = item
      const userId = this.$route.params.userId
      const { text_status, ting_status } = this.teacherInfo
      if (type === 'voice' && ting_status === 1) {
        this.$trackEvent('newprofilepages_listener_voice_click', {})
        EventBus.$emit('toQingsuOrder', {
          path: '/qingsu-order-page',
          query: {
            to_user_id: userId
          }
        })
      }
      if (type === 'text' && text_status === 1) {
        this.$trackEvent('newprofilepages_listener_texttalk_click', {})
        EventBus.$emit('toQingsuOrder', {
          path: '/consult-text/order-page',
          query: {
            to_user_id: userId
          }
        })
      }
    },
    onSelect(type) {
      this.$trackEvent(
        type === 'voice'
          ? 'newprofilepages_listener_voice'
          : 'newprofilepages_listener_texttalk'
      )
      this.$store.commit('homepage/SET_QINGSU_TYPE', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.hp-base-panel-wrp {
  &.hp-base-panel-wrp-new {
    background: url('~images/platform/homepage/service-bg.png') no-repeat;
    background-size: 686px 150px;
    // background: linear-gradient(180deg, #fff7f5 0%, #fff6f5 0%, #fff7f6 100%);
    padding-top: 0;
    margin-top: 30px;
    border-radius: 30px 30px 16px 16px;
  }
  .desc {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9da3ac;
    height: 76px;
    padding: 0 30px 0 24px;
    box-sizing: border-box;
    .icon-care {
      width: 147px;
      height: 28px;
      padding-right: 10px;
      border-right: 1px solid #eaeaea;
    }
    .desc-right {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      .desc-text {
        max-width: 430px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-left: 10px;

        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #fc7a5e;
        line-height: 28px;
      }
      .arrow-3 {
        width: 13px;
        height: 13px;
        object-fit: cover;
        margin-left: 0 !important;
      }
    }
  }
}
.qingsu-panel {
  padding: 30px;
  position: relative;
  .service-item {
    display: flex;
    box-sizing: border-box;
    padding: 0 30px;
    justify-content: space-between;
    align-items: center;
    height: 132px;
    background: #fff;
    border-radius: 20px;
    &.active {
      background: #fff8f6;
    }
    &:not(:first-child) {
      margin-top: 14px;
    }
    .title {
      display: flex;
      align-items: center;
      font-size: 32px;
      font-weight: 600;
      color: #21252d;
      line-height: 32px;
    }
    .tips {
      margin-left: 10px;
      font-size: 20px;
      font-weight: 500;
      color: #ff745b;
      line-height: 20px;
      padding: 8px 10px;
      background: #fff1e2;
      border-radius: 10px;
    }
    .price {
      margin-top: 18px;
      display: flex;
      align-items: baseline;
      .now {
        font-size: 30px;
        font-family: BebasKai;
        color: #ffa202;
        line-height: 42px;
        font-family: DharmaTypeBebasKai;
      }
      .origin,
      .package {
        font-size: 24px;
        color: #9da3ac;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 24px;
        margin-left: 10px;
      }
      .origin {
        text-decoration: line-through;
      }
    }
    .btn {
      width: 80px;
      height: 80px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
